import { IconFilter } from '../icons';
interface Props {
  appliedFiltersCount: number;
}
export const FilterButton = ({
  appliedFiltersCount
}: Props) => {
  return <span className='flex items-center gap-1 p-1 text-primary-main' data-sentry-component="FilterButton" data-sentry-source-file="filter-button.tsx">
            <IconFilter className='h-5 w-5' data-sentry-element="IconFilter" data-sentry-source-file="filter-button.tsx" />
            <span className='text-caption-12 font-medium'>فیلترها</span>
            {!!appliedFiltersCount && `(${appliedFiltersCount})`}
        </span>;
};